import {
  ArrowCounterclockwiseRegular,
  CheckmarkCircleRegular,
  DismissCircleRegular,
  type FluentIcon,
} from '@fluentui/react-icons';
import type { TTintBadgeColor } from '@shared/components/TintBadge';
import { EGateDecision, EStageStatus } from './types';

export const STAGE_STATUS_METADATA: Record<EStageStatus, { label: string; color: TTintBadgeColor }> = {
  [EStageStatus.COMPLETED]: { label: 'Completed', color: 'success' },
  [EStageStatus.CURRENT]: { label: 'In progress', color: 'blue' },
  [EStageStatus.UPCOMING]: { label: 'Upcoming', color: 'informative' },
  [EStageStatus.CANCELLED]: { label: 'Cancelled', color: 'danger' },
};

export const GATE_DECISION_METADATA: Record<
  EGateDecision,
  { label: string; decisionLabel: string; color: TTintBadgeColor; icon: FluentIcon }
> = {
  [EGateDecision.ACCEPT]: {
    label: 'Accept',
    decisionLabel: 'Accepted',
    color: 'success',
    icon: CheckmarkCircleRegular,
  },
  [EGateDecision.REWORK]: {
    label: 'Rework',
    decisionLabel: 'Rework required',
    color: 'warning',
    icon: ArrowCounterclockwiseRegular,
  },
  [EGateDecision.CANCEL]: {
    label: 'Cancel',
    decisionLabel: 'Cancelled',
    color: 'danger',
    icon: DismissCircleRegular,
  },
};
